export const getEmarsysProduct = (pk: string | number) => {
  if (typeof window === 'undefined') {
    return '';
  }

  const data = localStorage.getItem('product_breadcrumbs');
  if (data) {
    const parsedData = JSON.parse(data);
    const existingProduct = parsedData?.find(item => item.productPk == pk);
    
    if (existingProduct && existingProduct.breadcrumb) {
      return existingProduct.breadcrumb;
    }

    return '';
  }

  return '';
}